import React from "react";
import PropTypes from "prop-types";
import refreshIfNecessary from "./refreshIfNecessary";
import config from "../../config/common";

const withAdverts = WrappedComponent => {
  const {
    adverts: { adId, adPosition }
  } = config;

  class WithAdverts extends React.Component {
    constructor(props) {
      super(props);
      this.staticAdvertProps = {
        initialTargeting: this.props.targeting,
        id: adId
      };
    }

    displayName() {
      return `withAdverts(${
        WrappedComponent.displayName || WrappedComponent.name || "Component"
      })`;
    }

    componentDidUpdate(prevProps) {
      refreshIfNecessary(prevProps, this.props, adId);
    }

    render() {
      const {
        // eslint-disable-next-line no-unused-vars
        targeting,
        Advert,
        isDisplayed,
        itemCount,
        ...passThroughProps
      } = this.props;
      const advert = displayProps => (
        <Advert
          {...{
            ...this.staticAdvertProps,
            ...displayProps,
            isDisplayed
          }}
        />
      );

      const isInList = itemCount > adPosition;
      let listAdvert = null,
        footerAdvert = null;
      if (isInList) {
        listAdvert = advert;
      } else {
        footerAdvert = advert;
      }

      return (
        <WrappedComponent
          {...{
            itemCount,
            ...passThroughProps,
            listAdvert,
            footerAdvert
          }}
        />
      );
    }
  }

  WithAdverts.propTypes = {
    Advert: PropTypes.func,
    isDisplayed: PropTypes.bool.isRequired,
    targeting: PropTypes.object.isRequired,
    itemCount: PropTypes.number.isRequired
  };

  return WithAdverts;
};

export default withAdverts;
